import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
// import "element-ui/lib/theme-chalk/index.css";
import 'element-plus/dist/index.css'
import { post1, post2, post3 } from './assets/js/http'
import OptimizationUtils from './assets/js/Optimization.js'
import { specialRouter } from './utils/specialRouter.js'
import navigationPlugin from './utils/navigation.js'

const app = createApp(App)

// 注册Vue Router实例到全局，供specialRouter使用
window.__VUE_ROUTER_INSTANCE__ = router

// 注册全局属性
app.config.globalProperties.$http = post1
app.config.globalProperties.$httpOw = post2
app.config.globalProperties.$httpField = post3
app.config.globalProperties.$optimization = OptimizationUtils
app.config.globalProperties.$specialRouter = specialRouter

// 使用插件
app.use(store).use(router).use(ElementPlus, {
    locale: zhCn,
}).use(navigationPlugin)

// 挂载应用
app.mount('#app')